import { IDP } from '../lib/aoc';
import { IdPs } from '../constants/identityProviders';
export type IDPDescription = {
    idp: IDP;
    readableName: string;
    shortName: string;
    description: string;
    signoutURL: string;
};

export const providerList = [
    {
        idp: IdPs.None,
        readableName: 'Not Specified',
        shortName: 'Not Specified',
        description: '',
        signoutURL: '',
    },
    {
        idp: IdPs.AmazonFederate,
        readableName: 'Amazon Employee Login',
        shortName: 'Amazon Employee',
        description: 'Sign in as an Amazon Employee',
        signoutURL: 'https://midway-auth.amazon.com/logout',
    },
    {
        idp: IdPs.LoginWithAmazon,
        readableName: 'Login With Amazon',
        shortName: 'Amazon',
        description: 'Sign in with Amazon Retail Account',
        signoutURL: 'https://amazon.com/signout',
    },
    {
        idp: IdPs.AWSPartnerNetwork,
        readableName: 'AWS Partner Network',
        shortName: 'APN',
        description: 'Sign in with AWS Partner Network',
        signoutURL: 'https://partnercentral.awspartner.com/secur/logout.jsp',
    },
    {
        idp: IdPs.AWSBuilderID,
        readableName: 'AWS Builder ID',
        shortName: 'AWS Builder ID',
        description: 'Sign in with AWS Builder ID',
        signoutURL: 'https://profile.aws.amazon.com',
    },
    {
        idp: IdPs.OrganizationSSO,
        readableName: 'Organization SSO',
        shortName: 'Organization SSO',
        description: 'Sign in with SSO account',
        signoutURL: '',
    },
] as IDPDescription[];

export const getProvidersIncludingNone = () => providerList;

export const getProviders = () => providerList.filter((provider) => provider.idp !== 'None');

export const getProvider = (idp: IDP): IDPDescription => {
    return providerList.find((name) => name.idp === idp) ?? providerList[0];
};
